/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Flex } from "@chakra-ui/react";
import { Table } from "antd";
import { ColumnsType } from "antd/lib/table";
import { useState } from "react";
import { lastApprovedData } from ".";
import { Alert } from "../../components/Alert";
import { Avatar } from "../../components/Avatar";
import { useTransfer } from "../../hooks/useTransfer";
import { 
  formatCurrency, 
  formatDate, 
  getBackgroundColorForTransferStatus, 
  getColorForTransferStatus, 
  getTransferStatus, 
  showToast 
} from "../../utils";
import { CreateTransferModal } from "./_createTransferModal";

interface LastApprovedParams {
  lastApprovedData: Array<lastApprovedData>;
  ref: any;
}

export function LastApproved({
  lastApprovedData,
  ref
}: LastApprovedParams) {
  const [reprocessModalState, setReprocessModalState] = useState<boolean>(false);
  const [deleteModalState, setDeleteModalState] = useState<boolean>(false);
  const [deleteModalParamsState, setDeleteModalParamsState] = useState<any>();
  const [reprocessModalParamsState, setReprocessModalParamsState] = useState<any>();
  const { deleteAuthorize, postToDoTransfers } = useTransfer();
  const user = JSON.parse(localStorage.getItem("barte-user-info"));
  const approvedEmails = ["vinicius.telles2@barte.com", "guilherme.rocha.backoffice@barte.com"]
  const lastApproved: ColumnsType<any> = [
    {
      key: "sellerName",
      title: "Seller",
      dataIndex: "sellerName",
      render: (sellerName, record) => (
        <p>
          <Avatar name={record?.sellerName} />
        </p>
      )
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      render: (status, record) => (
        <Flex 
          align="center"
          justify="center"
          borderRadius="4px"
          bgColor={getBackgroundColorForTransferStatus(record?.status)}
          color={getColorForTransferStatus(record?.status)}
        >
          {getTransferStatus(record?.status)}
        </Flex>
      )
    },
    {
      key: "approvedDate",
      title: "Aprovação",
      dataIndex: "approvedDate",
      render: (approvedDate, record) => (
        <p>{approvedDate ? formatDate(record?.approvedDate) : "-"}</p>
      )
    },
    {
      key: "processDate",
      title: "Processamento",
      dataIndex: "processDate",
      render: (processDate, record) => (
        <p>{processDate ? formatDate(record?.processDate) : "-"}</p>
      )
    },
    {
      key: "amount",
      title: "Valor",
      dataIndex: "amount",
      render: (amount, record) => (
        <p>{formatCurrency({ value: record?.amount })}</p>
      )
    },
    {
      key: "button",
      title: "",
      dataIndex: "button",
      render: (item, record) => (
        <Flex align="center" gap="4">
          {(record?.status === "HAS_FAIL" || record?.status === "RETURNED") && (
            <Button
              variant="outline"
              maxW="100px"
              maxH="24px"
              color="#000000D9"
              fontWeight="400"
              fontSize="14px"
              borderRadius="2px"
              onClick={() => handleOpenReprocessRegistryModal(record)}
            >
              Reprocessar
            </Button>
          )}
          {(approvedEmails?.includes(user?.email)) && (
            <Button
              variant="outline"
              maxW="100px"
              maxH="24px"
              color="#FFF"
              bgColor="red"
              fontWeight="400"
              fontSize="14px"
              borderRadius="2px"
              onClick={() => handleOpenDeleteRegistryModal(record)}
            >
              Deletar
            </Button>
          )}
        </Flex>
      )
    }
  ];

  function handleOpenReprocessRegistryModal(record: any) {
    setReprocessModalParamsState({
      uuid: record?.transferBatchUuid,
      accountId: record?.accountId,
      sellerName: record?.sellerName,
      amount: record?.amount
    })
    setReprocessModalState(!reprocessModalState);
  }
  function handleOpenDeleteRegistryModal(record: any) {
    setDeleteModalParamsState({
      uuid: record?.transferBatchUuid,
      accountId: record?.accountId,
      sellerName: record?.sellerName,
      amount: record?.amount
    })
    setDeleteModalState(!reprocessModalState);
  }

  async function handleDelete() {
    try {
      await deleteAuthorize(deleteModalParamsState?.uuid);
      showToast({
        type: "success",
        message: "Sucesso na exclusão do registro!"
      })
      window.location.reload();
    } catch (err) {
      showToast({
        type: "error",
        message: "Falha na exclusão do registro!"
      })
    }
  }

  return (
    <>
      <Alert
        isOpen={deleteModalState}
        onClose={() => setDeleteModalState(!deleteModalState)}
        title="Tem certeza de que deseja excluir o repasse?"
        messageBody={`Deseja excluir o repasse de ${formatCurrency({ value: deleteModalParamsState?.amount })} para ${deleteModalParamsState?.sellerName}?`}
        confirmButtonText="Excluir"
        closeButtonText="Cancelar"
        onConfirm={handleDelete}
        leastDestructiveRef={ref}
      />
      <CreateTransferModal
        isOpen={reprocessModalState}
        onClose={() => setReprocessModalState(!reprocessModalState)}
        apiFunction={postToDoTransfers}
        selectedSeller={reprocessModalParamsState}
      />
      <Table<any>
        columns={lastApproved}
        dataSource={lastApprovedData}
        rowKey={(record) => record?.key}
        locale={{ emptyText: "Sem repasses finalizados!" }}
      />
    </>
  )
}
